import { toast } from 'react-toastify';
import { usersApi } from 'entities/users';

const createParticipantApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    createParticipant: builder.mutation({
      query: (form: any) => ({
        url: 'sales-point/admin/sales-point/admin/sales-points/',
        method: 'POST',
        body: form,
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно создали новую торговую точку', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
    createPhoneNumber: builder.mutation({
      query: ({ id, body }) => ({
        url: `sales-point/admin/sales-point/admin/sales-points/${id}/phones/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно создали номер для торговой точки', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
    updateParticipant: builder.mutation({
      query: ({ id, body }) => ({
        url: `/sales-point/admin/sales-point/admin/sales-points/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно изменили торговую точку', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
    deletePhone: builder.mutation<any, { sales_id: number; id: number }>({
      query: ({ sales_id, id }) => ({
        url: `sales-point/admin/sales-point/admin/sales-points/${sales_id}/phones/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно удалили номер', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
    deleteShop: builder.mutation<any, number>({
      query: (id) => ({
        url: `sales-point/admin/sales-point/admin/sales-points/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно удалили торговую точку', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return ['User'];
      },
    }),
  }),
});

export const {
  useCreateParticipantMutation,
  useCreatePhoneNumberMutation,
  useUpdateParticipantMutation,
  useDeletePhoneMutation,
  useDeleteShopMutation,
} = createParticipantApi;
